module.exports = __webpack_public_path__ + "static/media/bank.4e26bd25.svg";